import type { Author, MediaItem, ResolveResponse } from "./types";

const columns = [
  "record_type",
  "post_id",
  "parent_post_id",
  "depth",
  "username",
  "display_name",
  "text",
  "published_at",
  "permalink",
  "media_count",
  "media_urls"
] as const;

function escapeCell(value: string | number): string {
  const text = String(value);
  return /[",\r\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
}

function mediaURLs(items: MediaItem[]): string {
  return items.map((item) => item.url).join("\n");
}

function row(values: readonly (string | number)[]): string {
  return values.map(escapeCell).join(",");
}

function authorValues(author: Author): [string, string] {
  return [author.username, author.displayName || ""];
}

export function buildThreadCsv(result: ResolveResponse): string {
  const rows = [
    row(columns),
    row([
      "main_post",
      result.source.postId,
      "",
      0,
      ...authorValues(result.author),
      result.text,
      result.publishedAt || "",
      result.source.canonicalUrl,
      result.media.length,
      mediaURLs(result.media)
    ])
  ];

  if (result.quotedPost) {
    rows.push(row([
      "quoted_post",
      result.quotedPost.postId,
      result.source.postId,
      0,
      ...authorValues(result.quotedPost.author),
      result.quotedPost.text,
      "",
      "",
      result.quotedPost.media.length,
      mediaURLs(result.quotedPost.media)
    ]));
  }

  for (const reply of result.replies) {
    rows.push(row([
      "reply",
      reply.postId,
      reply.parentPostId,
      reply.depth,
      ...authorValues(reply.author),
      reply.text,
      reply.publishedAt || "",
      reply.permalink,
      reply.media.length,
      mediaURLs(reply.media)
    ]));
  }

  return `${rows.join("\r\n")}\r\n`;
}
